import React from 'react'
import ICSDataGrid from '../../../../components/ICSDataGrid/ICSDataGrid'
import { renderDateTime } from '../../../../utils/dateFormatter'
import { useDispatch } from 'react-redux'
import { dataSlice } from '../../../../redux/slices'

interface SelectedFile {
  id: string
  displayName: string
  startDate: string
  endDate: string
  extension: string
  vehicle: { name: string, displayName: string }
}

export const ShowDataGrid: React.FC<{ selectedFiles: SelectedFile[] }> = ({
  selectedFiles
}) => {
  const dispatch = useDispatch()

  // Handle selection changes
  const handleRemove = (rowData) => {
    dispatch(dataSlice.actions.toggleVersion(rowData.id))
  }

  const ActionColumn = (row) => {
    return (
      <button className="btn-warning" onClick={() => handleRemove(row.data)}>
        <span
          className={`glyphicons ${
            row?.entity?.enabled ? 'glyphicons-ok' : ' glyphicons-ban-circle'
          }`}
        ></span>
      </button>
    )
  }

  return (
    <div>
      <ICSDataGrid
        dataSource={selectedFiles}
        options={{ hideFilter: true, hideButtonRow: true }}
        columnOptions={[
          {
            dataField: 'action',
            caption: 'Action',
            cellRender: ActionColumn,
            width: '40px'
          },
          {
            dataField: 'startDate',
            caption: 'Start',
            cellRender: renderDateTime
          },
          {
            dataField: 'endDate',
            caption: 'End',
            cellRender: renderDateTime
          },
          { dataField: 'displayName', caption: 'Name' },
          {
            dataField: 'extension',
            caption: 'Extension',
            cellRender: RenderExtension
          },
          { dataField: 'vehicle.displayName', caption: 'Vehicle' }
        ]}
      />
    </div>
  )
}

const RenderExtension = (ext: { value: string }) => {
  return ext.value.toUpperCase()
}
